<div [formGroup]="parentForm" class="grid">
    <pixl-global-metadata-select
            [parentForm]="parentForm"
            [consumerMetadataIds]="consumerMetadataIdsArr"
            targetArrayName="consumerMetadata"
            class="full-width">
    </pixl-global-metadata-select>
</div>